import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { GamingService } from '@app/services/gaming.service';
import { commonComponents } from '@app/shared/common components/common components';
import { finalize } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'app-add-exclusion',
  templateUrl: './add-exclusion.component.html',
  styleUrls: ['./add-exclusion.component.css']
})
export class AddExclusionComponent implements OnInit {
  inputField = commonComponents.exclusion.AddExclusion;
  formData: Record<string, any> = { is_dap: true };
  isLoading = false;
  errorFormate: string;
  @Output() response = new EventEmitter<any>();
  tosterMessage = {
    message: '',
    type: ''
  };

  constructor(private addExclusion: GamingService) { }

  ngOnInit() { }

  getMaxLength(fieldName: string): number | string {
    if (fieldName === 'dob') return 10;
    if (fieldName === 'record_id') return 7;
    if (fieldName === 'universal_player_id') return 10;
    return '';
  }

  validateDOB(input: string): string | null {
    const parts = input.split('/');
    if (parts.length !== 3) return 'Invalid date format. Use MM/DD/YYYY.';
    const [month, date, year] = parts.map((p) => parseInt(p, 10));
    const currentYear = new Date().getFullYear();

    if (month < 1 || month > 12) return 'Invalid month: must be between 1 and 12.';
    if (date < 1 || date > 31) return 'Invalid date: must be between 1 and 31.';
    if (year >= currentYear) return 'Invalid year: must be less than the current year.';
    return null;
  }

  validateNumberField(event: any, name: string) {
    let input = event.target.value;
    this.errorFormate = '';

    if (name === 'universal_player_id') {
      input = input.toUpperCase();
      this.formData[name] = input;
    } else if (name === 'record_id') {
      input = input.replace(/[^0-9+]/g, '');
      event.target.value = input;
      this.formData[name] = input;
    } else if (name === 'dob') {
      input = input.replace(/[^0-9]/g, '');
      if (input.length > 2 && input.length <= 4) {
        input = `${input.slice(0, 2)}/${input.slice(2)}`;
      } else if (input.length > 4) {
        input = `${input.slice(0, 2)}/${input.slice(2, 4)}/${input.slice(4, 8)}`;
      }
      const error = this.validateDOB(input);
      if (error) {
        this.errorFormate = error;
        return;
      }
      this.formData[name] = input;
    }
  }

  cancelForm() {
    this.formData = { is_dap: true };
    this.errorFormate = '';
  }

  submitForm() {
    console.log(this.formData)
    const requiredFields = commonComponents.exclusion.fieldChecking;
    for (const field of requiredFields) {
      if (!this.formData[field]) {
        this.tosterMessage = {
          message: 'Please enter all required data.',
          type: 'error'
        };
        return;
      }
    }
    console.log(this.formData);
    this.isLoading = true;

    this.addExclusion.createExclusionList(this.formData)
      .pipe(
        finalize(() => (this.isLoading = false))
      )
      .subscribe(
        (response) => {
          this.tosterMessage = {
            message: 'The candidate has been added successfully.',
            type: 'success'
          };
          console.log('Gaming Exclusion List created successfully', response);
          setTimeout(() => {
            this.response.emit('success');
          }, 1200);
        },
        (error) => {
          console.error(error);
          this.tosterMessage = {
            message: 'Update failed',
            type: 'failed'
          };
          this.response.emit('failure');
        }
      );
  }
}
